import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormsBean } from '../../common.types';

type FlatFieldProps = Pick<FormContextValues<MedicalLeaveCommonFormsBean>, 'register'>;

export const FlatField = (props: FlatFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('address.flat', {
            maxLength: 50,
         })}
         label={commonTranslationKeys.flatNo}
         testId={'flat'}
         className={'flat'}
      />
   );
};
